// This function now receives `record` dynamically
export const getNiapData = (record) =>
  Object.entries(record.niap_analysis || {}).map(([niap, details], index) => ({
    id: index,
    name: niap,
    requirement: details.choice,
    feature: details.class,
    description: details.description,
  }));

// Static columns definition
export const niapColumns = [
  {
    Header: "Identifier",
    accessor: "name",
  },
  {
    Header: "Requirement",
    accessor: "requirement",
  },
  {
    Header: "Feature",
    accessor: "feature",
  },
  {
    Header: "Description",
    accessor: "description",
  },
];

export const niapTitle = "category-title-niap";
